// Check if CartInventoryValidator already exists to prevent duplicate declarations
if (typeof CartInventoryValidator === 'undefined') {
  class CartInventoryValidator {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('cartDrawerOpened', (event) => {
        this.validateCartInventory(event);
      });
      
      document.addEventListener('cartUpdated', (event) => {
        setTimeout(() => {
          this.validateCartInventory(event);
        }, 200);
      });
      
      document.addEventListener('click', this.handleRemoveAllOutOfStock.bind(this));
      
      if (document.getElementById('main-cart-items')) {
        setTimeout(() => {
          this.validateCartInventory();
        }, 100);
      }
    }

    handleRemoveAllOutOfStock(event) {
      if (event.target.matches('[data-action="remove-all-out-of-stock"]')) {
        event.preventDefault();
        this.removeAllOutOfStockItems();
      }
    }

    async removeAllOutOfStockItems() {
      const button = document.querySelector('[data-action="remove-all-out-of-stock"]');
      if (!button) return;

      const originalText = button.textContent;
      button.textContent = 'Removing...';
      button.disabled = true;

      try {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        if (cartData.items.length === 0) return;

        const inventoryData = await this.fetchInventoryDataEfficiently(cartData.items);
        
        const outOfStockVariantIds = [];
        
        cartData.items.forEach(item => {
          const inventoryInfo = inventoryData[item.variant_id];
          if (inventoryInfo && this.checkIfOutOfStock(inventoryInfo, item.quantity)) {
            outOfStockVariantIds.push(item.variant_id);
          }
        });

        if (outOfStockVariantIds.length > 0) {
          await this.removeItemsFromCart(outOfStockVariantIds);
          this.refreshCartPage();
        }
        
      } catch (error) {
        console.error('Error removing out of stock items:', error);
      } finally {
        button.textContent = originalText;
        button.disabled = false;
      }
    }

    async removeItemsFromCart(variantIds) {
      try {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        const updates = {};
        
        cartData.items.forEach(item => {
          updates[item.key] = item.quantity;
        });
        
        variantIds.forEach(variantId => {
          const item = cartData.items.find(item => item.variant_id === parseInt(variantId));
          if (item) {
            updates[item.key] = 0;
          }
        });
        
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates })
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          console.error('Failed to update cart:', errorData);
          throw new Error('Failed to update cart');
        }
        
      } catch (error) {
        console.error('Error removing items from cart:', error);
      }
    }

    refreshCart() {
      if (typeof window._cartRefresh === 'function') {
        window._cartRefresh();
      } else {
        window.location.reload();
      }
    }

    refreshCartPage() {
      const cartPage = document.getElementById('main-cart-items');
      if (cartPage) {
        window.location.reload();
      } else {
        this.refreshCart();
      }
    }

    async validateCartInventory(event = null) {
      let targetContext = null;
      
      if (event && event.type === 'cartDrawerOpened') {
        targetContext = 'drawer';
      } else if (event && event.type === 'cartUpdated') {
        targetContext = 'both';
      } else {
        targetContext = 'page';
      }
      
      const cartPage = document.getElementById('main-cart-items');
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (targetContext === 'drawer' && cartDrawer) {
        const cartItems = cartDrawer.querySelectorAll('.cart-item');
        if (cartItems.length > 0) {
          await this.validateCartContext(cartItems, cartDrawer);
        }
      } else if (targetContext === 'page' && cartPage) {
        const cartItems = cartPage.querySelectorAll('.cart-item');
        if (cartItems.length > 0) {
          await this.validateCartContext(cartItems, cartPage);
        }
      } else if (targetContext === 'both') {
        if (cartPage) {
          const cartPageItems = cartPage.querySelectorAll('.cart-item');
          if (cartPageItems.length > 0) {
            await this.validateCartContext(cartPageItems, cartPage);
          }
        }
        if (cartDrawer) {
          const cartDrawerItems = cartDrawer.querySelectorAll('.cart-item');
          if (cartDrawerItems.length > 0) {
            await this.validateCartContext(cartDrawerItems, cartDrawer);
          }
        }
      } else {
        const cartPageItems = cartPage ? cartPage.querySelectorAll('.cart-item') : null;
        const cartDrawerItems = cartDrawer ? cartDrawer.querySelectorAll('.cart-item') : null;
        const itemsToValidate = cartPageItems || cartDrawerItems;
        const cartContainer = cartPage || cartDrawer;
        
        if (cartContainer && itemsToValidate && itemsToValidate.length > 0) {
          await this.validateCartContext(itemsToValidate, cartContainer);
        }
      }
    }

    async validateCartContext(cartItems, container) {
      try {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && container === cartDrawer) {
          await this.rebuildCartDrawer();
          cartItems = cartDrawer.querySelectorAll('.cart-item');
        }
        
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        if (cartData.items.length === 0) return;

        const inventoryData = await this.fetchInventoryDataEfficiently(cartData.items);
        
        this.updateCartItemsWithInventory(cartItems, cartData.items, inventoryData);
        
        this.moveOutOfStockItemsToSection(cartItems, cartData.items, inventoryData, container);
        
      } catch (error) {
        console.error('Error validating cart inventory:', error);
      }
    }

    async rebuildCartDrawer() {
      try {
        const response = await fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`);
        const responseText = await response.text();
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      } catch (error) {
        console.error('Error rebuilding cart drawer:', error);
      }
    }

    restoreAvailableItems(container, cartDataItems, inventoryData) {
      const movedItems = container.querySelectorAll('.cart-item[data-moved-to-out-of-stock="true"]');
      
      movedItems.forEach(cartItem => {
        const variantId = cartItem.querySelector('[data-quantity-variant-id]')?.getAttribute('data-quantity-variant-id');
        if (!variantId) return;
        
        const cartDataItem = cartDataItems.find(item => item.variant_id === parseInt(variantId));
        if (!cartDataItem) return;
        
        const inventoryInfo = inventoryData[variantId];
        if (!inventoryInfo) return;
        
        const isOutOfStock = this.checkIfOutOfStock(inventoryInfo, cartDataItem.quantity);
        
        if (!isOutOfStock) {
          cartItem.style.display = '';
          cartItem.removeAttribute('data-moved-to-out-of-stock');
          cartItem.classList.remove('cart-item--out-of-stock');
          
          const messageElement = cartItem.querySelector('.cart-item__out-of-stock-message');
          if (messageElement) {
            messageElement.remove();
          }
          
          const quantityInput = cartItem.querySelector('.quantity__input');
          const quantityButtons = cartItem.querySelectorAll('.quantity__button');
          
          if (quantityInput) {
            quantityInput.disabled = false;
            quantityInput.style.opacity = '1';
            quantityInput.classList.remove('disabled');
          }
          
          quantityButtons.forEach(button => {
            button.disabled = false;
            button.style.opacity = '1';
            button.classList.remove('disabled');
          });
        }
      });
    }

    async fetchInventoryDataEfficiently(cartItems) {
      const inventoryData = {};
      
      if (cartItems.length === 0) return inventoryData;

      try {
        const response = await fetch('/?section_id=cart-inventory-data');
        const html = await response.text();
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const inventoryItems = doc.querySelectorAll('.cart-inventory-item');
        
        inventoryItems.forEach((item, index) => {
          const variantId = item.getAttribute('data-variant-id');
          if (variantId) {
            const inventoryInfo = {
              available: item.getAttribute('data-available') === 'true',
              inventory_quantity: parseInt(item.getAttribute('data-inventory-quantity') || '0'),
              inventory_management: item.getAttribute('data-inventory-management'),
              inventory_policy: item.getAttribute('data-inventory-policy')
            };
            
            inventoryData[variantId] = inventoryInfo;
          }
        });
        
      } catch (error) {
        console.error('Error fetching inventory data:', error);
      }
      
      return inventoryData;
    }

    updateCartItemsWithInventory(cartItems, cartDataItems, inventoryData) {
      this.clearAllOutOfStockMessages(cartItems);
      
      const itemsToProcess = Math.min(cartItems.length, cartDataItems.length);
      
      for (let i = 0; i < itemsToProcess; i++) {
        const cartItem = cartItems[i];
        const cartDataItem = cartDataItems[i];
        
        if (!cartDataItem) continue;

        const variantId = cartDataItem.variant_id;
        const inventoryInfo = inventoryData[variantId];
        
        if (!inventoryInfo) continue;

        const isOutOfStock = this.checkIfOutOfStock(inventoryInfo, cartDataItem.quantity);
        
        if (isOutOfStock) {
          this.markItemAsOutOfStock(cartItem, inventoryInfo, cartDataItem.quantity);
        } else {
          this.markItemAsInStock(cartItem);
        }
      }
    }

    clearAllOutOfStockMessages(cartItems) {
      cartItems.forEach((cartItem, index) => {
        cartItem.classList.remove('cart-item--out-of-stock');
        
        const messageElement = cartItem.querySelector('.cart-item__out-of-stock-message');
        if (messageElement) {
          messageElement.remove();
        }
        
        const quantityInput = cartItem.querySelector('.quantity__input');
        const quantityButtons = cartItem.querySelectorAll('.quantity__button');
        
        if (quantityInput) {
          quantityInput.disabled = false;
          quantityInput.style.opacity = '1';
          quantityInput.classList.remove('disabled');
        }
        
        quantityButtons.forEach(button => {
          button.disabled = false;
          button.style.opacity = '1';
          button.classList.remove('disabled');
        });
      });
    }

    checkIfOutOfStock(inventoryInfo, cartQuantity) {
      if (inventoryInfo.inventory_management !== 'shopify') {
        return false;
      }

      if (inventoryInfo.inventory_policy === 'continue') {
        return false;
      }

      const isOutOfStock = !inventoryInfo.available || cartQuantity > inventoryInfo.inventory_quantity;
      
      return isOutOfStock;
    }

    addOutOfStockMessageToItem(cartItem, inventoryInfo, cartQuantity) {
      const existingMessage = cartItem.querySelector('.cart-item__out-of-stock-message');
      if (existingMessage) {
        existingMessage.remove();
      }
      
      const messageElement = document.createElement('div');
      messageElement.className = 'cart-item__out-of-stock-message';
      
      // Check if this item has a .cart-item__details element (cart page structure)
      const detailsElement = cartItem.querySelector('.cart-item__details');
      if (detailsElement) {
        // This is a cart page item with details structure, append to details
        detailsElement.appendChild(messageElement);
      } else {
        // This is a cart drawer item or cloned item, append to cart item
        cartItem.appendChild(messageElement);
      }

      let message = '';
      if (!inventoryInfo.available) {
        message = 'This item is currently out of stock.';
      } else if (cartQuantity > inventoryInfo.inventory_quantity) {
        message = 'Less than requested quantity available.';
      }

      messageElement.textContent = message;
      messageElement.style.display = 'block';
    }

    markItemAsOutOfStock(cartItem, inventoryInfo, cartQuantity) {
      cartItem.classList.add('cart-item--out-of-stock');
      
      this.addOutOfStockMessageToItem(cartItem, inventoryInfo, cartQuantity);

      if (!inventoryInfo.available) {
        const quantityInput = cartItem.querySelector('.quantity__input');
        if (quantityInput) {
          quantityInput.disabled = true;
          quantityInput.style.opacity = '0.5';
        }

        const quantityButtons = cartItem.querySelectorAll('.quantity__button');
        quantityButtons.forEach(button => {
          button.disabled = true;
          button.style.opacity = '0.5';
        });
      }
    }

    markItemAsInStock(cartItem) {
      cartItem.classList.remove('cart-item--out-of-stock');
      
      const messageElement = cartItem.querySelector('.cart-item__out-of-stock-message');
      if (messageElement) {
        messageElement.remove();
      }

      const quantityInput = cartItem.querySelector('.quantity__input');
      if (quantityInput) {
        quantityInput.disabled = false;
        quantityInput.style.opacity = '1';
      }

      const quantityButtons = cartItem.querySelectorAll('.quantity__button');
      quantityButtons.forEach(button => {
        button.disabled = false;
        button.style.opacity = '1';
      });
    }

    moveOutOfStockItemsToSection(cartItems, cartDataItems, inventoryData, container = null) {
      const cartPage = document.getElementById('main-cart-items');
      const cartDrawer = !cartPage ? document.querySelector('cart-drawer') : null;
      const targetContainer = container || cartPage || cartDrawer;
      
      if (!targetContainer) return;

      if (cartPage && targetContainer === cartPage) {
        this.handleCartPageOutOfStockSection(cartItems, cartDataItems, inventoryData, cartPage);
        return;
      }

      let outOfStockSection = targetContainer.querySelector('.cart-out-of-stock-section');
      let outOfStockItems = targetContainer.querySelector('.cart-out-of-stock-items');
      
      if (!outOfStockSection) {
        outOfStockSection = this.createOutOfStockSection();
        const cartItemsContainer = targetContainer.querySelector('cart-drawer-items') || targetContainer.querySelector('cart-items');
        if (cartItemsContainer) {
          cartItemsContainer.insertBefore(outOfStockSection, cartItemsContainer.firstChild);
        }
      }

      if (!outOfStockItems) {
        outOfStockItems = outOfStockSection.querySelector('.cart-out-of-stock-items');
      }

      if (outOfStockItems) {
        outOfStockItems.innerHTML = '';
      }

      const outOfStockItemsToMove = [];
      
      cartItems.forEach((cartItem, index) => {
        const cartDataItem = cartDataItems[index];
        if (!cartDataItem) return;

        const variantId = cartDataItem.variant_id;
        const inventoryInfo = inventoryData[variantId];
        
        if (!inventoryInfo) return;

        const isOutOfStock = this.checkIfOutOfStock(inventoryInfo, cartDataItem.quantity);
        
        if (isOutOfStock) {
          outOfStockItemsToMove.push({
            cartItem: cartItem,
            cartDataItem: cartDataItem,
            inventoryInfo: inventoryInfo
          });
        }
      });

      outOfStockItemsToMove.forEach(itemData => {
        const { cartItem, cartDataItem, inventoryInfo } = itemData;
        
        const clonedCartItem = cartItem.cloneNode(true);
        
        clonedCartItem.classList.add('cart-item--out-of-stock');
        
        this.addOutOfStockMessageToItem(clonedCartItem, inventoryInfo, cartDataItem.quantity);
        
        if (inventoryInfo.available && cartDataItem.quantity > inventoryInfo.inventory_quantity) {
          const quantityInput = clonedCartItem.querySelector('.quantity__input');
          const quantityButtons = clonedCartItem.querySelectorAll('.quantity__button');
          
          if (quantityInput) {
            quantityInput.disabled = false;
            quantityInput.style.opacity = '1';
          }
          
          quantityButtons.forEach(button => {
            button.disabled = false;
            button.style.opacity = '1';
          });
        }
        
        if (outOfStockItems) {
          outOfStockItems.appendChild(clonedCartItem);
        }
        
        cartItem.style.display = 'none';
        
        cartItem.setAttribute('data-moved-to-out-of-stock', 'true');
      });

      if (outOfStockSection) {
        if (outOfStockItemsToMove.length > 0) {
          outOfStockSection.style.display = 'block';
        } else {
          outOfStockSection.style.display = 'none';
        }
      }
    }

    handleCartPageOutOfStockSection(cartItems, cartDataItems, inventoryData, cartPage) {
      const outOfStockSection = cartPage.querySelector('.cart-out-of-stock-section');
      
      this.restoreAvailableItems(cartPage, cartDataItems, inventoryData);

      if (outOfStockSection) {
        const existingItems = outOfStockSection.querySelectorAll('tr:not(.cart-out-of-stock-header-row)');
        existingItems.forEach(item => item.remove());
      }

      const outOfStockItemsToMove = [];
      
      cartItems.forEach((cartItem, index) => {
        const cartDataItem = cartDataItems[index];
        if (!cartDataItem) return;

        const variantId = cartDataItem.variant_id;
        const inventoryInfo = inventoryData[variantId];
        
        if (!inventoryInfo) return;

        const isOutOfStock = this.checkIfOutOfStock(inventoryInfo, cartDataItem.quantity);
        
        if (isOutOfStock) {
          outOfStockItemsToMove.push({
            cartItem: cartItem,
            cartDataItem: cartDataItem,
            inventoryInfo: inventoryInfo
          });
        }
      });

      outOfStockItemsToMove.forEach(itemData => {
        const { cartItem, cartDataItem, inventoryInfo } = itemData;
        
        const clonedCartItem = cartItem.cloneNode(true);
        
        clonedCartItem.classList.add('cart-item--out-of-stock');
        
        this.addOutOfStockMessageToItem(clonedCartItem, inventoryInfo, cartDataItem.quantity);
        
        if (inventoryInfo.available && cartDataItem.quantity > inventoryInfo.inventory_quantity) {
          const quantityInput = clonedCartItem.querySelector('.quantity__input');
          const quantityButtons = clonedCartItem.querySelectorAll('.quantity__button');
          
          if (quantityInput) {
            quantityInput.disabled = false;
            quantityInput.style.opacity = '1';
          }
          
          quantityButtons.forEach(button => {
            button.disabled = false;
            button.style.opacity = '1';
          });
        }
        
        if (outOfStockSection) {
          outOfStockSection.appendChild(clonedCartItem);
        }
        
        cartItem.style.display = 'none';
        
        cartItem.setAttribute('data-moved-to-out-of-stock', 'true');
      });

      if (outOfStockSection) {
        if (outOfStockItemsToMove.length > 0) {
          outOfStockSection.style.display = 'table-row-group';
        } else {
          outOfStockSection.style.display = 'none';
        }
      }
    }

    createOutOfStockSection() {
      const section = document.createElement('div');
      section.className = 'cart-out-of-stock-section';
      
      section.innerHTML = `
        <div class="cart-out-of-stock-header">
          <div class="cart-out-of-stock-warning">
            <svg class="icon icon-warning" aria-hidden="true" focusable="false" viewBox="0 0 24 24">
              <path d="M12 2L1 21h22L12 2zm0 3.17L19.83 19H4.17L12 5.17zM11 16h2v2h-2zm0-6h2v4h-2z"/>
            </svg>
            <span>The following items are no longer available. Please edit or remove them to continue.</span>
          </div>
          <button 
            type="button" 
            class="button button--secondary cart-remove-all-out-of-stock"
            data-action="remove-all-out-of-stock"
            aria-label="Remove all out of stock items"
          >
            REMOVE ALL
          </button>
        </div>
        <div class="cart-out-of-stock-items"></div>
      `;
      
      return section;
    }
  }

  if (!window.cartInventoryValidatorInitialized) {
    document.addEventListener('DOMContentLoaded', () => {
      if (!window.cartInventoryValidatorInstance) {
        window.cartInventoryValidatorInstance = new CartInventoryValidator();
        window.cartInventoryValidatorInitialized = true;
      }
    });
  }
} 